import moment from 'moment';

// Lightweight TradingConnector entity wrapper.
// Corresponds to WaveWise.WebApp.Models.Responses.TradingConnector
export default class TradingConnector {
  constructor(data) {
    this.Id = data.Id;
    this.Name = data.Name || '';
    this.Type = data.Type;
    this.Mode = data.Mode;
    this.KeyIdMask = data.KeyIdMask || null;
    this.HasKeyId = data.HasKeyId || false;
    this.SecretKeyMask = data.SecretKeyMask || null;
    this.HasSecretKey = data.HasSecretKey || false;
    this.UserId = data.UserId;
    this.OwnerName = data.OwnerName || null;

    if (data.CreateTime !== undefined) {
      this.CreateTime = (data.CreateTime === null) ? null : moment.utc(data.CreateTime);
    }
    if (data.UpdateTime !== undefined) {
      this.UpdateTime = (data.UpdateTime === null) ? null : moment.utc(data.UpdateTime);
    }
  }

  getFormattedCreateTime() {
    return this.CreateTime ? this.CreateTime.local().format('L LTS') : '';
  }

  getFormattedUpdateTime() {
    return this.UpdateTime ? this.UpdateTime.local().format('L LTS') : '';
  }

  getTypeDisplay() {
    return this.Type || '';
  }

  getModeDisplay() {
    return this.Mode || '';
  }
}
